import { render } from "./AddLocation.vue?vue&type=template&id=6d934a99&scoped=true"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"

import "./AddLocation.vue?vue&type=style&index=0&id=6d934a99&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d934a99"]])

export default __exports__